import { PlayerEvent } from 'bitmovin-player';
import { UIManager } from 'bitmovin-player-ui';
import { customSpecificErrorMessageOverlayConfig } from '../js/playeractions/handlers/customerrors';
import { localizationConfig } from '../js/settings/localization';
import { nativeMobileUIContainer, sendCustomMessage } from './nativemobileuicontainer';
import { CustomMessages } from '../types/interfaces';
import { getElementByQuery } from '../js/utilities/utilities.element';
import { handleLiveStreamNoDvr } from './handlers/domhandlers';
import { removeReplayClass } from '../js/playeractions/handlers/removereplayclass';
import { processNicam } from '../services/nicamHandlers/nicamhandler';
let adBreakActive = false;
export function nativeMobileUiFactory(player, config = {}) {
    UIManager.setLocalizationConfig(localizationConfig);
    const nicamClass = '.bmpui-nicam';
    const uiConfig = {
        ...config,
        errorMessages: customSpecificErrorMessageOverlayConfig,
        disableAutoHideWhenHovered: true
    };
    const mobileUIManager = new UIManager(player, nativeMobileUIContainer(player), uiConfig);
    let _webData = {};
    const removeFinishedClass = () => {
        player.off(PlayerEvent.Seek, removeFinishedClass);
        removeReplayClass(player);
    };
    const updateUI = () => {
        const seekbarTitleElement = getElementByQuery({
            container: player.getContainer(),
            query: '.bmpui-seekbar-label-title'
        });
        if (_webData.assets.preroll) {
            adBreakActive = true;
            player.on(PlayerEvent.AdBreakFinished, setAdBreakActiveToFalse);
            player.on(PlayerEvent.AdError, setAdBreakActiveToFalse);
        }
        if (_webData.metadata?.ageRating || _webData.metadata?.nicam) {
            const webDataPlayerContext = {
                npoplayer: {
                    streamObject: {
                        metadata: {
                            ageRating: _webData.metadata.ageRating,
                            nicam: _webData.metadata.nicam
                        }
                    }
                }
            };
            const nicamElement = getElementByQuery({ container: player.getContainer(), query: nicamClass });
            processNicam(webDataPlayerContext, nicamElement);
        }
        if (seekbarTitleElement)
            seekbarTitleElement.textContent = _webData.title || '';
        handleLiveStreamNoDvr(player, _webData);
    };
    const setAdBreakActiveToFalse = () => {
        adBreakActive = false;
        player.off(PlayerEvent.AdBreakFinished, setAdBreakActiveToFalse);
        player.off(PlayerEvent.AdError, setAdBreakActiveToFalse);
    };
    if (window.bitmovin?.customMessageHandler) {
        const handleData = (data) => {
            if (data) {
                const newData = JSON.parse(data);
                if (data !== _webData.toString()) {
                    _webData = newData;
                    updateUI();
                }
            }
        };
        window.bitmovin.customMessageHandler.on(CustomMessages.SET_STREAM_LINK, handleData);
        window.bitmovin.customMessageHandler.on(CustomMessages.SET_WEB_DATA, handleData);
        window.bitmovin.customMessageHandler.on(CustomMessages.DO_ERROR, (data) => {
            if (!data)
                return;
            const messageData = JSON.parse(data);
            if (messageData.errorMessage) {
                doError(messageData.errorMessage);
            }
        });
    }
    const addEventListeners = () => {
        player.off(PlayerEvent.Ready, addEventListeners);
        sendCustomMessage(CustomMessages.JAVASCRIPT_READY);
    };
    const doError = (data) => {
        window.bitmovin.customMessageHandler.off(CustomMessages.DO_ERROR, data.toString());
        const input = data.input;
        if (input) {
            const uiComponents = mobileUIManager.activeUi.getUI().getComponents();
            const errorMessageOverlay = uiComponents.find((component) => component.getConfig().cssClass === 'ui-errormessage-overlay');
            if (!errorMessageOverlay)
                return;
            try {
                errorMessageOverlay.display(input);
            }
            catch {
                return;
            }
        }
    };
    const onPlayerError = (event) => {
        player.off(PlayerEvent.Error, (event) => {
            onPlayerError(event);
        });
        sendCustomMessage(CustomMessages.ERROR_TRIGGERED, { error: event });
    };
    player.on(PlayerEvent.Seek, removeFinishedClass);
    player.on(PlayerEvent.Ready, addEventListeners);
    player.on(PlayerEvent.Error, (event) => {
        onPlayerError(event);
    });
    return mobileUIManager;
}
